// extracted by mini-css-extract-plugin
export var attribution = "_d4-4";
export var authorName = "_d4-5";
export var quote = "_d4-3";
export var testimonial = "_d4-2";
export var trustedBy = "_d4-0";
export var trustedByLabel = "_d4-1";